




























import { Component, Vue, Prop } from 'vue-property-decorator';
import { CNodeTopic, CNodeMessage } from '@/interface/cnode.interface';
import BaseMarkDown from './BaseMarkDown.vue';
@Component({
  components: {
    BaseMarkDown,
  },
  filters: {
    type(t: 'reply' | 'at') {
      return t === 'reply' ? '回复' : '@';
    },
  },
})
export default class BaseMessage extends Vue {
  @Prop({ required: true })
  private data!: CNodeMessage;
}
